import { DrugSearchConfiguration } from 'src/shared/storage/drugSearch'

import {
  DrugPriceUnion,
  DrugPriceUnionDrugPriceReject,
  DrugSearchPricesQueryResult,
  AnyPharmacy,
  AnyPharmacyPbmRetailPharmacy,
  AnyPharmacyMailOrderPharmacy,
} from '../api/drugSearchPricesQuery'

import { RequestData } from './types'

export const defaultConfig = {
  drugName: '',
  isDrugCovered: false,
  isDevice: false,
  config: {
    daysSupply: '',
    daysSupplyCustom: '',
    form: '',
    dosage: '',
    typeOfQuantity: '',
    quantity: '',
    ndc: '',
    gpi: '',
  },
}

export const prepareVariables = (
  savedDrugs: DrugSearchConfiguration[],
  requestData: RequestData,
) => {
  const savedDrug = savedDrugs.find(
    ({ drugName }) => drugName === requestData.drugName,
  )

  return {
    ndc: savedDrug!.config.ndc,
    gpi: savedDrug!.config.gpi,
    days_supply: Number(savedDrug?.config.daysSupplyCustom),
    quantity: Number(savedDrug?.config.quantity),
    latitude: requestData.latitude,
    longitude: requestData.longitude,
  }
}

export function isMailOrderPrice(
  price: DrugPriceUnion,
): price is DrugPriceUnion & {
  pharmacy: AnyPharmacyMailOrderPharmacy
} {
  return price.pharmacy.kind === 'MailOrderPharmacy'
}

export function isPbmRetailPrice(
  price: DrugPriceUnion | null,
): price is DrugPriceUnion & {
  pharmacy: AnyPharmacyPbmRetailPharmacy
} {
  return price?.pharmacy.kind === 'PbmRetailPharmacy'
}

export function isDrugRejection(
  data: DrugSearchPricesQueryResult,
): data is DrugSearchPricesQueryResult & {
  drugSearchPrices: DrugPriceUnionDrugPriceReject
} {
  return data?.drugSearchPrices.kind === 'DrugRejection'
}

export function isPbmRetailPharmacy(pharmacy: AnyPharmacy) {
  return pharmacy.kind === 'PbmRetailPharmacy'
}

export function isRejectedPrice(price: DrugPriceUnion) {
  return price.kind === 'DrugPriceReject'
}
